<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">
    {{#if isDefault}}
        {{TR "Verfügbare Felder"}}
    {{else}}{{TR "Benutzergruppierung"}}{{#if oriGroupName}} - {{oriGroupName}}{{/if}}{{/if}}</h4>
</div>
<div class="modal-body">
    {{#if isDefault}}
        {{FIELDS_LIST_BOX data.selectedFields 'col_multi_select' 'columns' fields}}
    {{else}}
        {{#if errors.error}}
        <div class="alert alert-danger">{{TR errors.error}}</div>
        {{/if}}
        {{#WIZARD wizardContext}}
            {{#if filterConfig.isFilter}}
            {{#WIZARD-TAB 'Filter'}}
                {{{DEVICE-FILTER filterConfig}}}
            {{/WIZARD-TAB}}
            {{/if}}

            {{#WIZARD-TAB 'Devices'}}
                {{{DEVICE-SELECT filterConfig}}}
            {{/WIZARD-TAB}}

            {{#if isExpert}}
            {{#WIZARD-TAB 'Data'}}
                {{FIELDS_LIST_BOX data.selectedFields 'col_multi_select' 'columns' fields}}
            {{/WIZARD-TAB}}
            {{/if}}

            {{#WIZARD-TAB 'Group'}}
                <div class="form-group">
                    <div class="row m-t-15 m-b-20">
                        <div class="col-xs-12">
                            <label class="control-label" for="name-edt">{{TR "Name"}}</label>
                            <input type="text" class="form-control {{#if errors.name}}parsley-error{{/if}}" value="{{data.name}}" id="name-edt">
                            {{#if errors.name}}
                            <ul class="parsley-errors-list filled">
                                <li class="parsley-required">{{errors.name}}</li>
                            </ul>
                            {{/if}}
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-xs-12">
                            {{{PERMISSIONS_CONTROL permData}}}
                        </div>
                    </div>
                </div>
            {{/WIZARD-TAB}}
        {{/WIZARD}}
    {{/if}}
</div>
<div class="modal-footer">
    {{{WIZARD-BUTTONS wizardContext}}}
</div>
